import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import * as projectActions from "../../actions/projectActions";

import SupportResourcesList from "./SupportResourcesList";
import SupportResourcesFilters from "./SupportResourcesFilters";

const INITIAL_FILTERS_STATE = {
  customer: [],
  employee: []
};

const SupportResourcesPage = ({ actions, isMobile, loading, auth }) => {
  const [filters, setFilters] = useState(INITIAL_FILTERS_STATE);
  const [currentPage, setCurrentPage] = useState(0);
  const [refetching, setRefetching] = useState(false);

  useEffect(() => {
    actions.loadProjectsWithSupportResources();
  }, [actions]);

  const handleChangeFilters = (name, value) => {
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  const preparePaylod = (page) => ({
    customer: filters.customer.map((c) => c.value || c),
    employee: filters.employee.map((e) => e.value || e),
    page
  });

  const handlePageChange = (page) => {
    setCurrentPage(page);
    actions.loadProjectsWithSupportResources(preparePaylod(page));
  };

  const handleProjectChange = async (projectId, data) => {
    setRefetching(true);
    await actions.updateProjectSupportResources(projectId, {
      ...data,
      supportResources: data.supportResources
        .filter((item) => item.employee)
        .map((item) => ({
          employee: item.employee,
          order: parseInt(item.text)
        }))
    });
    await actions.loadProjectsWithSupportResources(preparePaylod(currentPage));
    setRefetching(false);
  };

  const handleResetFilters = () => {
    setFilters(INITIAL_FILTERS_STATE);
    setCurrentPage(0);
    actions.loadProjectsWithSupportResources(INITIAL_FILTERS_STATE);
  };

  const handleFilter = () => {
    setCurrentPage(0);
    actions.loadProjectsWithSupportResources(preparePaylod(0));
  };

  return (
    <React.Fragment>
      <SupportResourcesFilters
        isMobile={isMobile}
        filters={filters}
        page={currentPage}
        onChange={handleChangeFilters}
        onReset={handleResetFilters}
        onFilter={handleFilter}
        loading={loading || refetching}
        isNightMode={auth.isNightMode}
      />
      <SupportResourcesList
        page={currentPage}
        refetching={refetching}
        onPageChange={handlePageChange}
        onProjectChange={handleProjectChange}
      />
    </React.Fragment>
  );
};

SupportResourcesPage.propTypes = {
  actions: PropTypes.object,
  isMobile: PropTypes.bool,
  loading: PropTypes.bool,
  auth: PropTypes.object
};

function mapStatesToProps(state) {
  return {
    loading: state.reducers.loading,
    auth: state.reducers.auth
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        ...projectActions
      },
      dispatch
    )
  };
}

export default connect(
  mapStatesToProps,
  mapDispatchToProps
)(SupportResourcesPage);
